import groupsTemplate from './groups.template.html';

/*****************************************************************************
 * groupsComponent */
/**
 * @ngdoc   component
 * @module  books.ui.accountAdmin
 * @name    books.ui.accountAdmin.component:groups
 *
 * @description This is used to add a new account group or update an existing
 * account group in the account admin app. This allows the user to create
 * account groups for the purposes of reporting.
 *****************************************************************************/
export const groupsComponent = {
  template: groupsTemplate,
  controller: groupsController
}

/*****************************************************************************
 * Controller: groupsController
 *
 * Controller for the groups route.
 *****************************************************************************/
/* @ngInject */ function groupsController(
  $scope,
  $location,
  $q,
  Accounts,
  AccountSettings,
  Alert,
  BusyScreen,
  UserAgent,
  uiGridConstants
) {
  /** Self Reference. */ var mThis = this;

  /*---------------------------------------------------------------*/
  /* If the user is on a mobile device, we need to enable the      */
  /* touch drag and drop feature on the drag handle. Only the drag */
  /* handle is set so that the user can scroll through the lists.  */
  /*---------------------------------------------------------------*/
  mThis.mobileDevice = UserAgent.isIOSDevice() || UserAgent.isAndroid();

  /*----------------------------------------------------------*/
  /* Template for the actions options added to each grid row. */
  /*----------------------------------------------------------*/
  var actionsCellTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope">' +
    '<span><span style="cursor:pointer" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change {{row.entity.description}}" ng-click="grid.appScope.$ctrl.changeGroup(row.entity)"></span> &nbsp;</span>' +
    '<span><span style="cursor:pointer" class="glyphicon glyphicon-trash csm-grid-space-target" title="Remove {{row.entity.description}}" ng-click="grid.appScope.$ctrl.removeGroup(row.entity)"></span> &nbsp;</span>' +
    '</div>';

  /*---------------------------------*/
  /* Template to add double click    */
  /* functionality to each grid row. */
  /*---------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.$ctrl.changeGroup(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*----------------------*/
  /* Groups list options. */
  /*----------------------*/
  mThis.dgGroups = {
    enableRowHeaderSelection: false,
    appScope: $scope,
    enableCellEdit: false,
    enableColumnMenus: false,
    enableFiltering: true,
    enagleRowHashing: false,
    enableRowSelection: true,
    enableFullRowSelection: true,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: true,
    saveSort: true,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      mThis.dgGroups.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        displayName: 'Groups',
        field: 'description'
      },
      {
        displayName: 'Notes',
        field: 'notes',
        width: '45%'
      },
      {
        cellTemplate: actionsCellTemplate,
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        width: 70,
        displayName: 'Actions'
      }
    ]
  };

  /***************************************************************************
   * addGroup
   *
   * Called on the Create New Group button. Directs the user to the /group route.
   *
   * @params row  Row to be removed
   ***************************************************************************/
  mThis.addGroup = function () {
    $location.path('/groups/0');
  };

  /***************************************************************************
   * changeGroup
   *
   * Removes the row from the ui grid
   *
   * @params row  Row to be removed
   ***************************************************************************/
  mThis.changeGroup = function (group) {
    $location.path('/groups/' + group.id);
  };

  /***************************************************************************
   * removeGroup
   *
   * Removes the group from the database
   ***************************************************************************/
  mThis.removeGroup = function (group) {
    Alert.clear();
    Alert.confirm(
      'Are you sure you want to remove the ' + group.description + ' group?',
      'Remove group'
    ).then(function (result) {
      BusyScreen.promise(
        Accounts.dropGroup(group.id).then(
          function (resp) {
            mThis.accounts.forEach(function (acct) {
              if (acct.groupID == group.id) {
                acct.groupID = 0;
                acct.groupDescription = '';
              }
            });
            mThis.dgGroups.data.removeItem(group);
            Alert.success(group.description + ' removed');
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message(), group.description);
          }
        )
      );
    });
  };

  /***************************************************************************
   * $onInit */
  /**
   * Initializes the application by loading the groups and accounts.
   ***************************************************************************/
  mThis.$onInit = function () {
    BusyScreen.promise(
      $q.all([
        (mThis.dgGroups.data = AccountSettings.groups),
        (mThis.accounts = AccountSettings.accounts)
      ])
    );
  };
}
